import "./core/api-base-url";
import React from "react";
import { createRoot } from "react-dom/client";
import { App, ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import updateLocale from "dayjs/plugin/updateLocale";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppRoot from "./app";
import "./core/index.css";
import store from "./store/store";

dayjs.extend(updateLocale);
dayjs.locale("ru");
dayjs.updateLocale("ru", { weekStart: 1 });

const planTheme = {
  token: {
    colorPrimary: "#1b8c5a"
  }
};

ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider locale={ruRU} theme={planTheme}>
      <App>{children}</App>
    </ConfigProvider>
  )
});

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={ruRU} theme={planTheme}>
      <App className="plan-app-root">
        <Provider store={store}>
          <BrowserRouter>
            <AppRoot />
          </BrowserRouter>
        </Provider>
      </App>
    </ConfigProvider>
  </React.StrictMode>
);
